function getCurrentDateInMs() {
  return new Date().valueOf()
}

function getIsDocumentVisible() {
  return document.visibilityState === 'visible' || document.hidden === false
}

/**
 * Calls callback based on interval and document visibility. Returns unsubscribe function.
 * How it works:
 * - document is hidden: interval cleared
 * - document visible: interval set-up with remaining time from last interval. Call immediately if interval elapsed
 */
export function intervalCallbackOnWindowVisible(interval: number, callback: () => unknown) {
  let nextRefresh = getCurrentDateInMs() + interval
  let refreshTimeout: NodeJS.Timeout | null = null

  function refresh() {
    nextRefresh = getCurrentDateInMs() + interval
    // Queue next refresh
    refreshTimeout = setTimeout(refresh, interval)
    // Call callback asynchronously
    setTimeout(callback, 0)
  }

  /**
   * Handle the visibility change event, compute callback remaining time or call immediately
   */
  function handleVisibilityChange() {
    if (refreshTimeout) clearTimeout(refreshTimeout)

    if (getIsDocumentVisible()) {
      const currentDateMs = getCurrentDateInMs()
      // Refresh if the document is stale, otherwise set a timeout to refresh later
      if (nextRefresh <= currentDateMs) {
        refresh()
      } else {
        refreshTimeout = setTimeout(refresh, nextRefresh - currentDateMs)
      }
    }
  }

  if (getIsDocumentVisible()) {
    refreshTimeout = setTimeout(refresh, interval)
  }

  document.addEventListener('visibilitychange', handleVisibilityChange)

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }
}
